import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@chakra-ui/react";
import {
  Box,
  Flex,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  Link,
  Image,
} from "@chakra-ui/react";
import ktxImg from "./images/ktx.svg";
import ktxHoverImg from "./images/ktx_hover.svg";

import { AppHeaderLinks, AppDrawerLinks } from "./AppHeaderLinks";
import MoreSelector from "./MoreSelector";
import menuIcon from "./images/menu.svg";
import closeIcon from "./images/close.svg";

export default function Header() {
  const [opacity, setOpacity] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();
  const [isHoverLogo, setIsHoverLogo] = useState(false);

  const [isSmallMobile] = useMediaQuery(`(max-width: 600px)`);
  const [isMobile] = useMediaQuery(`(max-width: 750px)`);
  const [isPc] = useMediaQuery(`(min-width: 800px)`);
  const isPad = !isMobile && !isPc;

  useEffect(() => {
    onClose();
  }, [location.pathname, onClose]);

  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    setOpacity(scrollTop / 100);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Flex
        direction={"column"}
        position="fixed"
        top="0"
        left="0"
        right="0"
        zIndex={"999"}
        bg={`rgba(0, 0, 0, ${opacity})`}
      >
        <Flex
          py="14px"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          px={isMobile ? "12px" : "24px"}
          gap={"12px"}
          width="100%"
        >
          <Flex
            flex="1"
            direction="row"
            alignItems="center"
            flexWrap={"wrap"}
            gap={"16px"}
          >
            {isPad || isMobile ? (
              <Image
                src={menuIcon}
                boxSize={"20px"}
                cursor={"pointer"}
                onClick={onOpen}
              />
            ) : null}
            <Link
              isExternal
              mr="8px"
              flexShrink={0}
              href="https://www.ktx.finance/"
              onMouseEnter={() => setIsHoverLogo(true)}
              onMouseLeave={() => setIsHoverLogo(false)}
            >
              <Image
                src={isHoverLogo ? ktxHoverImg : ktxImg}
                alt={"KTC"}
                boxSize="30px"
              />
            </Link>
            {isPc || isPad ? (
              <Box borderRight={"1px solid #344054"} h={"16px"}></Box>
            ) : null}
            {isSmallMobile ? null : <AppHeaderLinks mr="auto" showAll={isPc} />}
          </Flex>
          {isPc || isPad ? (
            <Flex>
              <MoreSelector />
            </Flex>
          ) : null}
        </Flex>
      </Flex>

      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement="left"
        autoFocus={false}
      >
        <DrawerOverlay
          bg="rgba(14, 21, 32, 0.60)"
          backdropFilter={"blur(16.5px)"}
        />
        <DrawerContent bg={"gray.sombre"} w="260px">
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            px={"24px"}
            py={"14px"}
          >
            <Link
              isExternal
              mr="8px"
              flexShrink={0}
              href="https://www.ktx.finance/"
            >
              <Image src={ktxImg} alt={"KTC"} boxSize="30px" />
            </Link>
            <Image
              src={closeIcon}
              cursor={"pointer"}
              boxSize="24px"
              onClick={onClose}
            />
          </Flex>
          <Box overflowY={"auto"}>
            <AppDrawerLinks showAll={isSmallMobile} />
            <Flex>
              <MoreSelector isMobile />
            </Flex>
          </Box>
        </DrawerContent>
      </Drawer>
    </div>
  );
}
